export default "__VITE_ASSET__CMMgUQTX__"